import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { RootService } from 'src/app/shared/services/root.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component'
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { environment } from '../../../environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { secureStorage } from '../../shared/services/encryption/secureservice'//'src/app/shared/services/encryption/secureservice';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { SeoService } from 'src/app/shared/seo/seo.service';


declare var $;

@Component({
  selector: 'app-profile',
  templateUrl: 'profile.component.html',
  styleUrls: ['profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  userData: any;
  breadcrumbData: any = [];
  page: any;
  sub: Subscription = new Subscription
  environment1 = environment.s3bucket.url;
  isMobile: boolean = false;
  isAllowToEdit: boolean = false;
  maximumSize: any = 6;
  dealerCode: any;
  userBalance: any;
  userBal: boolean = true;
  userBalLocalSto: any;
  showLoader: boolean = false;
  loyalityborder: boolean =false;
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']

  constructor(
    private activatedRoute: ActivatedRoute, private secureService: RootService,
    private regexService: RegexService, private router: Router,
    public skeletonService: SkeletonService,
    @Inject(PLATFORM_ID) private platformId: Object, private apiService: ApiService,
    private commonService: CommonService,
    private cleverService: ClevertapService, private localStorage: secureStorage,
    private behaviourSubject: BehaviourSubjectService,private seoservice: SeoService
    

  ) {

  }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      $('.header').addClass('p-scroll');
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
        this.maximumSize = 4

        // some code..
      } else {
        this.isMobile = false;
        this.maximumSize = 6
      }
      try {
        this.cleverService.onPageView("Profile Page");
      } catch { }
      if (isPlatformBrowser(this.platformId)) {
      this.dealerCode = localStorage.getItem("dealercd") ? true : false;
      }
    }
    this.userData = this.secureService.getUserData();
    this.getLoyalityUserBalance();
    this.behaviourSubject.loyalityUserBalance.subscribe((res) => {
      this.userBalance = res ? res : 0;
      if (this.userBalance >= 0) {
        this.userBal = false
      }
    })
    this.activatedRoute.paramMap.subscribe(params => {
      if (params?.get('page')) {
        this.page = params.get('page');
        this.tabChange(this.page)
      }
      else {
        this.tabChange('profilePage')
        this.page = 'profilePage';
      }
    });
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('VASDataProfile')
    let dealercdforloyality = localStorage.getItem('dealercd');
    }
    // this.loyalityborder = this.schemeDealeCodes.includes(dealercdforloyality) ? true : false

  }



  @Output() goBackto: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBackto.emit();
  }



  clickToLogout() {
    // this.sub.add(this.apiService.logoutApi('').subscribe({
    //   next: (res) => {
    if (!this.isAllowToEdit) {
      this.router.navigate(['/'])
      if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('wishlist');
      }
      this.userData = null;
      this.secureService.logout();
    }
    //   },
    //   error: (err) => {
    //   }
    // }))
  }












  tabChange(item: any) {
if (isPlatformBrowser(this.platformId)) {
    // this.orderDetailsIndex = null;
    localStorage.removeItem('localBreadCrumb');
}
    this.page = item == 'booking' ? 'Bookings' : item;
    if (this.page == 'wishList') {
      this.commonService.showBreadCrumbb('wishList');
    } else if (this.page == 'profilePage') {
      this.commonService.showBreadCrumbb('profile');
    }
    else if (this.page == 'testDrive') {
      // this.status = 'upcoming'
      this.commonService.showBreadCrumbb('test drive');
      // this.currentPage = 1
      // this.getTestDriveData({ "offset": 0, "size": 10, "status": ["Request Accepted", "PENDING", "C1 (Quote Tendered)"] });
    } else if (this.page == 'bookings') {
      this.commonService.showBreadCrumbb('Bookings');
      // this.currentPageBooking = 1
      // this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
    } else if (this.page == 'notifications') {
      this.breadcrumbData = ['account', 'notifications']
      this.commonService.showBreadCrumbb('notifications');
    } else if (this.page == 'kyc') {
      // this.breadcrumbData = ['account', 'kyc']
      this.commonService.showBreadCrumbb('kyc');
    }
    // else if (this.page == 'vas') {
    //   this.breadcrumbData = ['account', 'vas']
    //   this.commonService.showBreadCrumbb('vas');
    //   // this.currentPageBooking = 1
    //   var reqBody = {
    //     "offset": 0,
    //     "limit": 10
    //   }
    //   // this.getVASData(reqBody)
    // }
    else if (this.page == 'configuration') {
      // this.currentPageConfigurator = 1
      // let req = {
      //   "from_date": "",
      //   "to_date": "",
      //   "type": "all",
      //   "offset": 0,
      //   "row": 9
      // };
      // this.getconfiguratorDetails(req);
      this.breadcrumbData = ['account', 'configuration']
      this.commonService.showBreadCrumbb('configuration');
    }
    else {
      this.commonService.showBreadCrumbb(this.page);
    }
    this.breadCrumb?.getBreadCrumb()
    this.seoservice.callSchema();
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  goBack() {
    this.page = null;
  }
  menuClick(flag) {
    this.page = flag;
  }

  getLoyalityUserBalance() {
    const data = {
      mobile_number: this.userData.mobile_number,
      source: 'OSP',
    };
    try {
      // this.spinner.show();
      this.showLoader = true;

      this.sub.add(
        this.apiService.getUserBalance(data).subscribe({
          next: (res) => {
            if (res.success) {
              this.userBal = true
              this.userBalance = res.data["user_balance_list"][0];
              this.userBalLocalSto = res.data
              if (isPlatformBrowser(this.platformId)) {
              this.localStorage.setItem('userBalLocalSto', JSON.stringify(this.userBalLocalSto));
              }
              // this.spinner.hide();
            } else {
              // this.spinner.hide();
              console.warn('Response unsuccessful or data missing.');
            }
            // this.spinner.hide();
          },
          error: (err) => {
            // this.spinner.hide();
          },
          complete: () => {
            // this.spinner.hide();
            this.showLoader = false;
          },
        })
      );
    } catch (error) {

    }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }




}


